module.exports = __webpack_public_path__ + "prod/20251121165348/img/url-app.d88da72d.png";